var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGridLines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1436,
    height: 546,
    viewBox: "0 0 1436 546",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M55.5 0.5V546",
    stroke: "url(#paint0_linear_627_307)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13 0.5V546",
    stroke: "url(#paint1_linear_627_307)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M99 0.5V546",
    stroke: "url(#paint2_linear_627_307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.5 0.5V546",
    stroke: "url(#paint3_linear_627_307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186 0.5V546",
    stroke: "url(#paint4_linear_627_307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.5 0.5V546",
    stroke: "url(#paint5_linear_627_307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273 0.5V546",
    stroke: "url(#paint6_linear_627_307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.5 0.5V546",
    stroke: "url(#paint7_linear_627_307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 0.5V546",
    stroke: "url(#paint8_linear_627_307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.5 0.5V546",
    stroke: "url(#paint9_linear_627_307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447 0.5V546",
    stroke: "url(#paint10_linear_627_307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.5 0.5V546",
    stroke: "url(#paint11_linear_627_307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534 0.5V546",
    stroke: "url(#paint12_linear_627_307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.5 0.5V546",
    stroke: "url(#paint13_linear_627_307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621 0.5V546",
    stroke: "url(#paint14_linear_627_307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.5 0.5V546",
    stroke: "url(#paint15_linear_627_307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708 0.5V546",
    stroke: "url(#paint16_linear_627_307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.5 0.5V546",
    stroke: "url(#paint17_linear_627_307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795 0.5V546",
    stroke: "url(#paint18_linear_627_307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838.5 0.5V546",
    stroke: "url(#paint19_linear_627_307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882 0.5V546",
    stroke: "url(#paint20_linear_627_307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925.5 0.5V546",
    stroke: "url(#paint21_linear_627_307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969 0.5V546",
    stroke: "url(#paint22_linear_627_307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.5 0.5V546",
    stroke: "url(#paint23_linear_627_307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1056 0.5V546",
    stroke: "url(#paint24_linear_627_307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.5 0.5V546",
    stroke: "url(#paint25_linear_627_307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143 0.5V546",
    stroke: "url(#paint26_linear_627_307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.5 0.5V546",
    stroke: "url(#paint27_linear_627_307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230 0.5V546",
    stroke: "url(#paint28_linear_627_307)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1273.5 0.5V546",
    stroke: "url(#paint29_linear_627_307)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1317 0.5V546",
    stroke: "url(#paint30_linear_627_307)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1360.5 0.5V546",
    stroke: "url(#paint31_linear_627_307)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1404 0.5V546",
    stroke: "url(#paint32_linear_627_307)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0.5 40H1440",
    stroke: "url(#paint33_linear_627_307)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M0.5 84.75H1440",
    stroke: "url(#paint34_linear_627_307)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M0.5 129.5H1440",
    stroke: "url(#paint35_linear_627_307)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 174.25H1440",
    stroke: "url(#paint36_linear_627_307)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 219H1440",
    stroke: "url(#paint37_linear_627_307)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 263.75H1440",
    stroke: "url(#paint38_linear_627_307)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 308.5H1440",
    stroke: "url(#paint39_linear_627_307)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 353.25H1440",
    stroke: "url(#paint40_linear_627_307)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 398H1440",
    stroke: "url(#paint41_linear_627_307)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 442.75H1440",
    stroke: "url(#paint42_linear_627_307)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 487.5H1440",
    stroke: "url(#paint43_linear_627_307)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_627_307",
    x1: 56,
    y1: 0.5,
    x2: 56,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_627_307",
    x1: 13.5,
    y1: 0.5,
    x2: 13.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_627_307",
    x1: 99.5,
    y1: 0.5,
    x2: 99.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_627_307",
    x1: 143,
    y1: 0.5,
    x2: 143,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_627_307",
    x1: 186.5,
    y1: 0.5,
    x2: 186.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_627_307",
    x1: 230,
    y1: 0.5,
    x2: 230,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_627_307",
    x1: 273.5,
    y1: 0.5,
    x2: 273.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_627_307",
    x1: 317,
    y1: 0.5,
    x2: 317,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_627_307",
    x1: 360.5,
    y1: 0.5,
    x2: 360.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_627_307",
    x1: 404,
    y1: 0.5,
    x2: 404,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_627_307",
    x1: 447.5,
    y1: 0.5,
    x2: 447.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_627_307",
    x1: 491,
    y1: 0.5,
    x2: 491,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_627_307",
    x1: 534.5,
    y1: 0.5,
    x2: 534.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_627_307",
    x1: 578,
    y1: 0.5,
    x2: 578,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_627_307",
    x1: 621.5,
    y1: 0.5,
    x2: 621.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_627_307",
    x1: 665,
    y1: 0.5,
    x2: 665,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_627_307",
    x1: 708.5,
    y1: 0.5,
    x2: 708.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_627_307",
    x1: 752,
    y1: 0.5,
    x2: 752,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_627_307",
    x1: 795.5,
    y1: 0.5,
    x2: 795.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_627_307",
    x1: 839,
    y1: 0.5,
    x2: 839,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_627_307",
    x1: 882.5,
    y1: 0.5,
    x2: 882.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_627_307",
    x1: 926,
    y1: 0.5,
    x2: 926,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_627_307",
    x1: 969.5,
    y1: 0.5,
    x2: 969.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_627_307",
    x1: 1013,
    y1: 0.5,
    x2: 1013,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_627_307",
    x1: 1056.5,
    y1: 0.5,
    x2: 1056.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_627_307",
    x1: 1100,
    y1: 0.5,
    x2: 1100,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_627_307",
    x1: 1143.5,
    y1: 0.5,
    x2: 1143.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_627_307",
    x1: 1187,
    y1: 0.5,
    x2: 1187,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_627_307",
    x1: 1230.5,
    y1: 0.5,
    x2: 1230.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_627_307",
    x1: 1274,
    y1: 0.5,
    x2: 1274,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_627_307",
    x1: 1317.5,
    y1: 0.5,
    x2: 1317.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_627_307",
    x1: 1361,
    y1: 0.5,
    x2: 1361,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_627_307",
    x1: 1404.5,
    y1: 0.5,
    x2: 1404.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_627_307",
    x1: 720.25,
    y1: 40,
    x2: 720.25,
    y2: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_627_307",
    x1: 720.25,
    y1: 84.75,
    x2: 720.25,
    y2: 85.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_627_307",
    x1: 720.25,
    y1: 129.5,
    x2: 720.25,
    y2: 130.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_627_307",
    x1: 720.25,
    y1: 174.25,
    x2: 720.25,
    y2: 175.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_627_307",
    x1: 720.25,
    y1: 219,
    x2: 720.25,
    y2: 220,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_627_307",
    x1: 720.25,
    y1: 263.75,
    x2: 720.25,
    y2: 264.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_627_307",
    x1: 720.25,
    y1: 308.5,
    x2: 720.25,
    y2: 309.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_627_307",
    x1: 720.25,
    y1: 353.25,
    x2: 720.25,
    y2: 354.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_627_307",
    x1: 720.25,
    y1: 398,
    x2: 720.25,
    y2: 399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_627_307",
    x1: 720.25,
    y1: 442.75,
    x2: 720.25,
    y2: 443.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_627_307",
    x1: 720.25,
    y1: 487.5,
    x2: 720.25,
    y2: 488.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridLines);
export default __webpack_public_path__ + "static/media/gridLines.e103f3a5c23e6bbb91dd7f835b7c522d.svg";
export { ForwardRef as ReactComponent };